"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module  urgency
 * @decision Tracks urgency contacts, adds/removes them
 */

module.exports = function (config, get, post) {
	return {
		list: list,
		add: add,
		remove: remove,
		online: online,
		history: {
			create: create_history,
			update: update_history,
			list: { in : list_history_in,
				out: list_history_out
			}
		},
		preferences: {
			get: get_urgency_preferences,
			update: update_urgency_preferences
		}
	};

	/**
	 * Lists the urgency contact ids
	 * @return {Promise} Resolves to array of urgency contact ids
	 */
	function list() {
		return get("/v2/urgency/list", {});
	}

	/**
	 * Adds a person to the urgency contact list
	 * @param  {String}  who Id of person to add
	 * @return {Promise}     Resolves if addition was successful
	 */
	function add(who) {
		return post("/v2/urgency/add", {
			who: who
		});
	}

	/**
	 * Removes a person from the urgency contact list
	 * @param  {String}  who Id of person to remove
	 * @return {Promise}     Resolves if removal was successful
	 */
	function remove(who) {
		return post("/v2/urgency/remove", {
			who: who
		});
	}

	/**
	 * List the urgency contacts that are currently online
	 * @return {Promise}  Resolves to list of online contact ids
	 */
	function online() {
		return get("/v2/urgency/online");
	}

	/**
	 * Creates a new UrgencyCall history item
	 * @param  {Array<String>} online List of currently online urgency contacts
	 * @param {String}		Reason for the call eg. "press" (for button press)
	 * @return {Promise}              Resovles to UrgencyCall data on success
	 */
	function create_history(online, reason) {
		return post("/v2/urgency/history/create", {
			online: online,
			reason: reason
		});
	}

	/**
	 * Update the history of an urgency call
	 * @param  {String}        call   The id of the urgency call to update
	 * @param  {String}        event  Type of event to update with ["start", "call", "accept", "cancel", "cycle"]
	 * @param  {Array<String>} online List of currently online urgency contacts
	 * @param  {String}        who    Id of current person that's being called or who has accepted the call
	 * @return {Promise}              Resolves if updating was successful
	 */
	function update_history(call, event, online, who) {
		return post("/v2/urgency/history/update", {
			id: call,
			type: event,
			online: online,
			who: who
		});
	}

	/**
	 * Lists incoming urgency call history
	 * @param  {Number}  page Optional page to load (loads 8 at a time)
	 * @return {Promise}      Resovles to array of UrgenyCalls
	 */
	function list_history_in(page) {
		return get("/v2/urgency/history/list/in", {
			page: page
		});
	}

	/**
	 * Lists outgoing urgency call history
	 * @param  {Number}  page Optional page to load (loads 8 at a time)
	 * @return {Promise}      Resolves to array of UrgenyCalls
	 */
	function list_history_out(page) {
		return get("/v2/urgency/history/list/out", {
			page: page
		});
	}

	/**
	 * Gets the urgency call preferences for the current user
	 * @return {Promise} Resolves to object with urgency preferences
	 */
	function get_urgency_preferences() {
		return get("/v2/urgency/preferences/data");
	}

	/**
	 * Updates the current user's urgency preferences
	 * @param  {Object} updates The preferences to update. Current only 'ordered'
	 * @return {Promise}         Resolves to updates interpreted and accepted by the server
	 */
	function update_urgency_preferences(updates) {
		return post("/v2/urgency/preferences/update", updates);
	}
};
